"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MissedAnnualPaymentInfo = void 0;
class MissedAnnualPaymentInfo {
}
exports.MissedAnnualPaymentInfo = MissedAnnualPaymentInfo;
//# sourceMappingURL=MissedAnnualPaymentInfo.js.map